<template>
  <div class="reload-button-and-qr-section">
    <div class="reload-section">
      <button class="qr-reload-button" @click="onTapReload">
        <IconQrReload />
        QRコード再取得
      </button>
    </div>
    <VueQrcode
      v-if="hasNetworkSpeedIssue && qrString"
      class="network-error-last-successful-qr"
      :value="qrString"
      tag="img"
    />
  </div>
</template>

<script>
import IconQrReload from "@/views/Components/Atoms/IconQrReload.vue";

export default {
  name: "FaceQRReloadSectionCenteredQR",
  components: { IconQrReload },
  props: {
    onTapReload: {
      type: Function,
      required: true,
    },
    hasNetworkSpeedIssue: {
      type: Boolean,
      default: false,
    },
    qrString: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.reload-button-and-qr-section {
  background-color: #f4b53f;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.reload-section {
  display: flex;
  justify-content: center;
  align-items: center;
}

.qr-reload-button {
  border: none;
  border-radius: 18vw;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1vw;
  width: 87vw;
  height: 11.7vw;
  padding: 3.2vw 2.7vw;
  box-sizing: border-box;
  background: #fff;
  box-shadow: var(--defaultBoxShadow);
  color: #000;
  text-decoration: none;
  text-align: center;
  margin: 6vw 5vw;
  font-size: 3.7vw;
  font-weight: 700;
}

.qr-reload-button svg {
  width: 5.3vw;
  height: 5.3vw;
  flex-shrink: 0;
}

.network-error-last-successful-qr {
  width: 150px;
  height: 150px;
  padding: 10px;
  box-sizing: border-box;
}
</style>
